import * as yup from "yup";

import { Translations, i18n } from "../../i18n";
import { PasswordResetFormValues } from "./types";

export const validationSchema: yup.SchemaOf<PasswordResetFormValues> = yup
  .object()
  .shape({
    password: yup
      .string()
      .required(i18n.t(Translations.SignUpRoutePasswordRequired)),
    passwordConfirm: yup
      .string()
      .required(i18n.t(Translations.SignUpRoutePasswordRequired)),
  });
